/**
 * Saving a file the browser received through axios.
 *
 * Deliberately not `window.open(url)`: that leaves the axios instance behind,
 * so the Authorization header and the 401-refresh retry never apply. Every
 * export endpoint here is admin-only from day one, so an unauthenticated tab
 * would simply be refused.
 */

export const filenameFromDisposition = (disposition, fallback) => {
  const match = String(disposition || '').match(/filename="?([^";]+)"?/i);
  return match?.[1] || fallback;
};

export const downloadBlob = (blob, filename) => {
  const url = window.URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = filename;
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
  window.URL.revokeObjectURL(url);
};

/**
 * With `responseType: 'blob'` a 400/403 body arrives as a Blob, so
 * `error.response.data.detail` is undefined and every failure would otherwise
 * surface as a generic message.
 */
export const readBlobError = async (error) => {
  const payload = error?.response?.data;
  if (payload instanceof Blob) {
    try {
      return JSON.parse(await payload.text())?.detail || null;
    } catch (parseError) {
      return null;
    }
  }
  return payload?.detail || null;
};
